import { render, staticRenderFns } from "./ProveedoresEvaluacionPagination.vue?vue&type=template&id=e80358d8&"
import script from "./ProveedoresEvaluacionPagination.vue?vue&type=script&lang=js&"
export * from "./ProveedoresEvaluacionPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports